export default function Marquee({ items }) {
  const text = items || [
    "LIVE FROM BANGALORE", "TECHNO · INDUSTRIAL · DEEP HOUSE · AMBIENT",
    "FEEL THE MUSIC — FEEL THE SOUL", "BROADCASTING 24/7",
    "RAV3.LABS STUDIO CONTROL ROOM", "A PLATFORM FOR DJS",
  ];
  const line = text.join("   ///   ");
  return (
    <div className="w-full overflow-hidden border-y border-[#27272A] bg-[#0A0A0C] py-2" data-testid="marquee-ticker">
      <div className="marquee-track">
        <span className="mono-label text-[#E8552A] pr-8">{line}   ///   </span>
        <span className="mono-label text-[#E8552A] pr-8">{line}   ///   </span>
      </div>
    </div>
  );
}
